import { Link } from "react-router-dom";

export function Logo({ compact = false, inverse = false }: { compact?: boolean; inverse?: boolean }) {
  return (
    <Link className={`brand ${compact ? "brand--compact" : ""} ${inverse ? "brand--inverse" : ""}`} to="/" aria-label="Home">
      <img src={inverse ? "/brand/footer-logo.svg" : "/brand/logo.svg"} alt="Oxwell" />
    </Link>
  );
}
